import { ACTION_TYPES } from "../actions/user";
import { initialState } from "./initialState";

export function authentication(state = initialState.user, action) {
    switch (action.type) {
        case ACTION_TYPES.LOGIN_SUCCESS:
            return {
                loggedIn: true,
                user: action.payload
            };
        case ACTION_TYPES.LOGIN_FAILURE:
            return {};
        case ACTION_TYPES.LOGOUT:
            return {};
        default:
            return state
    }
}